import React from 'react';
import moment from 'moment';
import { Badge } from '@syneto/compass-react/lib';

// rest-api status vocabulary for a machine's licenses (GET /licensing/product-addons). 'pending active' is a
// grant with a future start date: it reads "Scheduled" on screen, never the raw status.
const SCHEDULED_STATUS = 'pending active';

// Calendar dates stored at UTC midnight (see client/helpers/addonPeriod.js): format them in UTC so
// a browser behind UTC does not show 29/10 for a license that ends on 30/10.
const formatDate = (value) => {
	return value ? moment.utc(value).format('DD/MM/YYYY') : 'N/A';
};

const Addons = (props) => {
	let { addons } = props;
	
	const renderAddonStatus = (status) => {
		const normalizedStatus = (status || '').toLowerCase();

		if (normalizedStatus === 'active' || normalizedStatus === 'trial') {
			return <Badge appearance="success">Active</Badge>;
		}
		if (normalizedStatus === 'expired') {
			return <Badge appearance="danger">Expired</Badge>;
		}
		if (normalizedStatus === SCHEDULED_STATUS) {
			return <Badge appearance="info">Scheduled</Badge>;
		}

		return <Badge appearance="info">{status}</Badge>;
	};

	return (
		addons?.length ?
			<table className="table table-hover">
				<thead>
					<tr>
						<th scope="col">Name</th>
						<th scope="col">Tier</th>
						<th scope="col">Status</th>
						<th scope="col">Start Date</th>
						<th scope="col">End Date</th>
					</tr>
				</thead>
				<tbody>
					{addons.map((addon, index) => {
						return (
							<tr key={index}>
								<td>{addon?.addon?.name}</td>
								<td>
									{addon?.tier?.name || 'N/A'}
									{addon?.tier?.unitOfMeasurement && ` (${addon.tier.unitOfMeasurement.symbol})`}
								</td>
								<td>{renderAddonStatus(addon?.status)}</td>
								<td>{formatDate(addon?.startDate)}</td>
								<td>{formatDate(addon?.endDate)}</td>
							</tr>
						);
					})}
				</tbody>
			</table> :
			<div>No license available</div>

	);
};

export default Addons;
